<template>
  <div class="moreInfo-box">
    <div class="add-box">
      <span
        href=""
        class="el-back"
        @click="back"
      ><i class="el-icon-refresh-left" /></span>
      <!-- 会员受助情况 -->
      <div class="caseInfo">
        <div class="title-line">
          <span class="divider-title">会员受助情况</span>
          <el-divider />
        </div>
        <div class="search-con">
          <div class="search-con-item">
            <label class="search-con-item__label">会员生存现状:</label>
            <span>
              <el-select
                v-model="moreInfo.aidInfo.memberAliveStatus"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.aliveFlagEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">目前医疗费用:</label>
            <span><el-input
              v-model="moreInfo.aidInfo.currentMedicalExpenses"
              placeholder="目前医疗费用"
            /></span>
            <span
              style="color: #99a9bf; margin-right: 10px; margin-left: 10px"
            >元</span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">会员本人是否知情:</label>
            <span>
              <el-select
                v-model="moreInfo.aidInfo.isMemberKnown"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.memberKnownFlagEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
          </div>
        </div>
      </div>
      <!-- 会员基本情况 -->
      <div class="caseInfo">
        <div class="title-line">
          <span class="divider-title">会员基本情况</span>
          <el-divider />
        </div>
        <div class="search-con">
          <div class="search-con-item">
            <label class="search-con-item__label">从事行业:</label>
            <span>
              <el-select
                v-model="moreInfo.baseInfo.profession"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.professionEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
            <span
              style="margin-left: 8px"
            ><el-input
              v-model="moreInfo.baseInfo.otherProfession"
              placeholder="其他"
            /></span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">公司类型:</label>
            <span>
              <el-select
                v-model="moreInfo.baseInfo.companyType"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.companyTypeEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">公司名称:</label>
            <span><el-input
              v-model="moreInfo.baseInfo.companyName"
              placeholder="公司名称"
            /></span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">公司规模:</label>
            <span><el-input
              v-model="moreInfo.baseInfo.companySize"
              placeholder="公司规模"
            /></span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">所在岗位:</label>
            <span>
              <el-select
                v-model="moreInfo.baseInfo.jobPosition"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.jobPositionEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">岗位描述:</label>
            <span><el-input
              v-model="moreInfo.baseInfo.positionDetail"
              placeholder="请描述具体的岗位名称或者职能"
            /></span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">对平台认可度:</label>
            <span>
              <el-select
                v-model="moreInfo.baseInfo.recognition"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.platformRecognitionEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
            <span
              style="margin-left: 8px"
            ><el-input
              v-model="moreInfo.baseInfo.recognitionReason"
              placeholder="请描述原因"
            /></span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">重要客户标记:</label>
            <span>
              <el-select
                v-model="moreInfo.baseInfo.importantCustomerMark"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.importantCustomerEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
            <span
              style="margin-left: 8px"
            ><el-input
              v-model="moreInfo.baseInfo.importantCustomerDetail"
              placeholder="其他"
            /></span>
          </div>
          <br>
          <div class="search-con-item" style="width: 100%">
            <span style="width: 100%">
              <el-input
                v-model="moreInfo.baseInfo.personCharacter"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10 }"
                placeholder="会员的性格特点:    如日常沟通中,普通话是否标准、比较健谈/不爱说话、性格是否开朗等"
              />
            </span>
          </div>
        </div>
      </div>

      <!-- 家庭成员背景情况 -->
      <div class="caseInfo">
        <div class="title-line">
          <span class="divider-title">家庭成员背景情况</span>
          <el-divider />
        </div>
        <div class="search-con">
          <div class="search-con-item">
            <label class="search-con-item__label">家庭年收入:</label>
            <span><el-input
              v-model="moreInfo.familyBackground.houseIncome"
              placeholder="家庭年收入"
            /></span>
            <span
              style="color: #99a9bf; margin-right: 10px; margin-left: 10px"
            >元</span>
          </div>
          <br>
          <div class="search-con-item" style="width: 100%">
            <span style="width: 100%">
              <el-input
                v-model="moreInfo.familyBackground.familyDescription"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 10 }"
                placeholder=" 家人描述"
              />
            </span>
          </div>
          <br>
          <br>
          <div
            v-for="(familyItem, index) in moreInfo.familyBackground
              .familyRecord"
            :key="index"
          >
            <div class="search-con-item">
              <label class="search-con-item__label">家庭成员:</label>
              <span>
                <el-select
                  v-model="familyItem.familyMember"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in allSelect.relationEnums"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  />
                </el-select>
              </span>
            </div>
            <div class="search-con-item">
              <label class="search-con-item__label">特殊行业标记:</label>
              <span>
                <el-select
                  v-model="familyItem.specialJobMark"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in allSelect.specialJobMarkEnums"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  />
                </el-select>
              </span>
            </div>
            <div class="search-con-item">
              <label class="search-con-item__label">姓名:</label>
              <span><el-input
                v-model="familyItem.name"
                placeholder="姓名"
              /></span>
            </div>
            <div class="search-con-item">
              <label class="search-con-item__label">电话号码:</label>
              <span><el-input
                v-model="familyItem.phoneNumber"
                placeholder="电话号码"
              /></span>
            </div>
            <div class="search-con-item">
              <label class="search-con-item__label">工作单位:</label>
              <span><el-input
                v-model="familyItem.employer"
                placeholder="工作单位"
              /></span>
            </div>
            <div class="search-con-item">
              <label class="search-con-item__label">职务:</label>
              <span><el-input
                v-model="familyItem.position"
                placeholder="职务"
              /></span>
            </div>
            <br>
            <br>
          </div>
        </div>
      </div>
      <!-- 推荐人及人脉关系-->
      <div class="caseInfo">
        <div class="title-line">
          <span class="divider-title">推荐人及人脉关系</span>
          <el-divider />
        </div>
        <div class="search-con">
          <div class="search-con-item">
            <label class="search-con-item__label">推荐人:</label>
            <span><el-input
              v-model="moreInfo.referrerRelationship.referrerName"
              placeholder="推荐人"
            /></span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">推荐人电话:</label>
            <span><el-input
              v-model="moreInfo.referrerRelationship.referrerPhoneNumber"
              placeholder="推荐人电话"
            /></span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">推荐关系:</label>
            <span>
              <el-select
                v-model="moreInfo.referrerRelationship.referRelation"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.referRelationEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">推荐人所在行业:</label>
            <span><el-input
              v-model="moreInfo.referrerRelationship.referrerEmployer"
              placeholder="推荐人所在行业"
            /></span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">推荐人岗位:</label>
            <span><el-input
              v-model="moreInfo.referrerRelationship.referrerPosition"
              placeholder="推荐人岗位"
            /></span>
          </div>
          <br>
          <div class="search-con-item" style="width: 100%">
            <span style="width: 100%">
              <el-input
                v-model="moreInfo.referrerRelationship.referDetail"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 10 }"
                placeholder=" 推荐详情"
              />
            </span>
          </div>
        </div>
      </div>
      <!-- 加入互助情况-->
      <div class="caseInfo">
        <div class="title-line">
          <span class="divider-title">加入互助情况</span>
          <el-divider />
        </div>
        <div class="search-con">
          <div class="search-con-item">
            <label class="search-con-item__label">加入其他互助:</label>
            <span>
              <el-select
                v-model="moreInfo.otherAidSituation.joinOtherAidFlag"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.joinOtherAidFlagEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
          </div>
          <br>
          <div class="search-con-item" style="width: 100%">
            <span style="width: 100%">
              <el-input
                v-model="moreInfo.otherAidSituation.otherAidArr"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10 }"
                placeholder=" 其他互助平台+互助金额"
              />
            </span>
          </div>
        </div>
      </div>
      <!-- 探访沟通情况-->
      <div class="caseInfo">
        <div class="title-line">
          <span class="divider-title">探访沟通情况</span>
          <el-divider />
        </div>
        <div class="search-con">
          <div class="search-con-item">
            <label class="search-con-item__label">探访意愿:</label>
            <span>
              <el-select
                v-model="moreInfo.visitingCommunication.visitWillingness"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.visitWillingnessEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
          </div>
          <br>
          <div class="search-con-item" style="width: 100%">
            <span style="width: 100%">
              <el-input
                v-model="moreInfo.visitingCommunication.communicateSituation"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10 }"
                placeholder="探访沟通详情"
              />
            </span>
          </div>
        </div>
      </div>
      <!-- 沟通情况 -->
      <div class="caseInfo">
        <div class="title-line">
          <span class="divider-title">沟通情况</span>
          <el-divider />
        </div>
        <div class="search-con">
          <div class="search-con-item">
            <label class="search-con-item__label">沟通难度:</label>
            <span><el-input
              v-model="
                moreInfo.historicalCommunication.communicationDifficulty
              "
              placeholder="是否容易理解沟通内容"
            /></span>
          </div>
        </div>
      </div>
      <el-button
        type="primary"
        icon="el-icon-edit"
        @click="saveSupplement"
      >保存资料</el-button>
    </div>
    <br>
    <div class="add-box">
      <!-- 不予互助沟通情况 -->
      <div class="caseInfo">
        <div class="title-line">
          <span class="divider-title">不予互助沟通情况</span>
          <el-divider />
        </div>
        <el-timeline style="margin-top: 25px">
          <el-timeline-item
            v-for="(item, index) in refusalCommunicateList"
            :key="index"
          >
            <h6>
              <span
                style="color: #99a9bf; margin-right: 10px"
              >不予互助沟通内容:</span>{{ item.refusalCommunicateContent }}
            </h6>
            <h6>
              <span style="color: #99a9bf; margin-right: 10px">用户反馈:</span>{{ item.feedbackContent }}
            </h6>
            <p>{{ item.operator }} 提交于 {{ item.date }}</p>
          </el-timeline-item>
        </el-timeline>
        <div class="search-con">
          <div class="search-con-item" style="width: 100%">
            <span style="width: 100%">
              <el-input
                v-model="refusalCommunicate.refusalCommunicateContent"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10 }"
                placeholder="不予互助沟通内容"
              />
            </span>
          </div>
        </div>
        <div class="search-con">
          <div class="search-con-item" style="width: 100%">
            <span style="width: 100%">
              <el-input
                v-model="refusalCommunicate.feedbackContent"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10 }"
                placeholder="用户反馈详情"
              />
            </span>
          </div>
        </div>
        <el-button
          type="primary"
          icon="el-icon-edit"
          @click="saveRefusalCommunicate"
        >保存不予互助沟通情况</el-button>
      </div>
    </div>
    <br>
    <div class="add-box">
      <!-- 事件概况 -->
      <div class="caseInfo">
        <div class="title-line">
          <span class="divider-title">事件概况</span>
          <el-divider />
        </div>
        <el-timeline style="margin-top: 25px">
          <el-timeline-item
            v-for="(item, index) in eventOverviewList"
            :key="index"
          >
            <h6>{{ item.content }}</h6>
            <p>{{ item.operator }} 提交于 {{ item.date }}</p>
          </el-timeline-item>
        </el-timeline>
        <div class="search-con">
          <div class="search-con-item" style="width: 100%">
            <span style="width: 100%">
              <el-input
                v-model="eventOverviewContent"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10 }"
                placeholder="事件概况内容"
              />
            </span>
          </div>
        </div>
        <el-button
          type="primary"
          icon="el-icon-edit"
          @click="saveEventOverview"
        >保存事件概况</el-button>
      </div>
    </div>
    <br>
    <div class="add-box">
      <!-- 历史沟通情况 -->
      <div class="caseInfo">
        <div class="title-line">
          <span class="divider-title">历史沟通情况</span>
          <el-divider />
        </div>
        <el-timeline style="margin-top: 25px">
          <el-timeline-item
            v-for="(item, index) in historicalCommunicationList"
            :key="index"
          >
            <h6>
              <span style="color: #99a9bf; margin-right: 10px">反馈渠道:</span>{{
                typeEnumsConvert(
                  item.feedbackChannel,
                  allSelect.feedbackChannelEnums
                )
              }}
            </h6>
            <h6>
              <span style="color: #99a9bf; margin-right: 10px">反馈类型:</span>{{
                typeEnumsConvert(item.feedbackType, allSelect.feedbackTypeEnums)
              }}
            </h6>
            <h6>
              <span style="color: #99a9bf; margin-right: 10px">沟通详情:</span>{{ item.communicationDetail }}
            </h6>
            <p>{{ item.operator }} 提交于 {{ item.date }}</p>
          </el-timeline-item>
        </el-timeline>

        <div class="search-con">
          <div class="search-con-item">
            <label class="search-con-item__label">反馈渠道:</label>
            <span>
              <el-select
                v-model="historicalCommunication.feedbackChannel"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.feedbackChannelEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
          </div>
          <div class="search-con-item">
            <label class="search-con-item__label">反馈类型:</label>
            <span>
              <el-select
                v-model="historicalCommunication.feedbackType"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in allSelect.feedbackTypeEnums"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </span>
          </div>
          <div class="search-con-item" style="width: 100%">
            <span style="width: 100%">
              <el-input
                v-model="historicalCommunication.communicationDetail"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10 }"
                placeholder="沟通详情"
              />
            </span>
          </div>
        </div>
        <el-button
          type="primary"
          icon="el-icon-edit"
          @click="saveHistoricalCommunicate"
        >保存历史沟通情况</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allSelect: {},
      moreInfo: {
        caseCode: null,
        version: 0,
        aidInfo: {
          currentMedicalExpenses: null,
          memberAliveStatus: null,
          isMemberKnown: null
        },
        baseInfo: {
          profession: null,
          otherProfession: null,
          companyType: null,
          companyName: null,
          companySize: null,
          jobPosition: null,
          positionDetail: null,
          recognition: null,
          recognitionReason: null,
          importantCustomerMark: null,
          importantCustomerDetail: null,
          personCharacter: null
        },
        familyBackground: {
          houseIncome: null,
          familyDescription: null,
          familyRecord: [
            {
              familyMember: null,
              specialJobMark: 0,
              name: null,
              phoneNumber: null,
              employer: null,
              position: null
            },
            {
              familyMember: null,
              specialJobMark: 0,
              name: null,
              phoneNumber: null,
              employer: null,
              position: null
            },
            {
              familyMember: null,
              specialJobMark: 0,
              name: null,
              phoneNumber: null,
              employer: null,
              position: null
            },
            {
              familyMember: null,
              specialJobMark: 0,
              name: null,
              phoneNumber: null,
              employer: null,
              position: null
            },
            {
              familyMember: null,
              specialJobMark: 0,
              name: null,
              phoneNumber: null,
              employer: null,
              position: null
            }
          ]
        },
        referrerRelationship: {
          referrerName: null,
          referrerPhoneNumber: null,
          referRelation: null,
          referrerEmployer: null,
          referrerPosition: null,
          referDetail: null
        },
        otherAidSituation: {
          joinOtherAidFlag: null,
          otherAidArr: null
        },
        historicalCommunication: {
          communicationDifficulty: null
        },
        visitingCommunication: {
          visitWillingness: null,
          communicateSituation: null
        }
      },
      // 不予互助沟通情况
      refusalCommunicate: {
        version: null,
        caseCode: null,
        refusalCommunicateContent: null,
        feedbackContent: null
      },
      // 不予互助沟通情况列表
      refusalCommunicateList: [],
      // 事件概况
      eventOverviewContent: null,
      // 事件概况列表
      eventOverviewList: [],
      // 历史沟通情况对象
      historicalCommunication: {
        version: null,
        caseCode: null,
        feedbackChannel: 0,
        feedbackType: 0,
        communicationDetail: null
      },
      // 历史沟通情况列表
      historicalCommunicationList: []
    }
  },

  created() {
    this.$emit('setCurrentMenu', '补充材料')
    this.getAllSelect()
    this.getMoreInfo()
  },

  methods: {
    back() {
      this.$router.go(-1)
    },
    getAllSelect() {
      this.axios
        .get(this.homePath() + '/case-info/information-supplement/enums/list')
        .then((res) => {
          if (res.data.status == '000000') {
            this.allSelect = res.data.data
          } else {
            this.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    changeSelect(val, type) {
      console.log(val)
    },

    getMoreInfo() {
      const caseCode = this.$route.params.caseCode
      this.moreInfo.caseCode = caseCode
      this.getEventOverview()
      this.geTrefusalCommunicate()
      this.getHistoricalCommunication()

      this.axios
        .get(this.homePath() + '/case-info/information-supplement/' + caseCode)
        .then((res) => {
          const result = res.data
          if (result.status == '000000') {
            this.moreInfo.caseCode = result.data.caseCode
            this.moreInfo.version = result.data.version
            this.moreInfo.aidInfo =
              result.data.aidInfo != null
                ? result.data.aidInfo
                : this.moreInfo.aidInfo
            this.moreInfo.baseInfo =
              result.data.baseInfo != null
                ? result.data.baseInfo
                : this.moreInfo.baseInfo
            this.moreInfo.familyBackground =
              result.data.familyBackground != null
                ? result.data.familyBackground
                : this.moreInfo.familyBackground
            this.moreInfo.referrerRelationship =
              result.data.referrerRelationship != null
                ? result.data.referrerRelationship
                : this.moreInfo.referrerRelationship
            this.moreInfo.otherAidSituation =
              result.data.otherAidSituation != null
                ? result.data.otherAidSituation
                : this.moreInfo.otherAidSituation
            this.moreInfo.visitingCommunication =
              result.data.visitingCommunication != null
                ? result.data.visitingCommunication
                : this.moreInfo.visitingCommunication
            this.moreInfo.historicalCommunication =
              result.data.historicalCommunication != null
                ? result.data.historicalCommunication
                : this.moreInfo.historicalCommunication

            const familyRecordNum = this.moreInfo.familyBackground
            // 如果家人的记录行数小于5条，即补充条数
            if (
              familyRecordNum.familyRecord == null ||
              familyRecordNum.familyRecord.length < 5
            ) {
              if (this.moreInfo.familyBackground == null) {
                this.moreInfo.familyBackground == []
              }
              if (this.moreInfo.familyBackground.familyRecord == null) {
                this.moreInfo.familyBackground.familyRecord = []
              }
              // 循环补充记录
              const currentNum = familyRecordNum.familyRecord.length
              for (let i = 0; i < 5 - currentNum; i++) {
                const failmyData = this.familyRecordItemObj()
                this.moreInfo.familyBackground.familyRecord.push(failmyData)
              }
            }
          } else {
            this.$alert(result.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    getEventOverview() {
      // 获取概况列表
      this.axios
        .get(
          this.homePath() +
            '/case-info/information-supplement/event-overview/list/' +
            this.moreInfo.caseCode
        )
        .then((res) => {
          const result = res.data
          if (result.status == '000000') {
            this.eventOverviewList = result.data.eventOverviews
            if (result.data.version != null) {
              this.moreInfo.version = result.data.version
            }
          } else {
            this.$alert(result.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    geTrefusalCommunicate() {
      // 获取不予互助沟通情况列表
      this.axios
        .get(
          this.homePath() +
            '/case-info/information-supplement/refusal-communicate/list/' +
            this.moreInfo.caseCode
        )
        .then((res) => {
          const result = res.data
          if (result.status == '000000') {
            this.refusalCommunicateList = result.data.refusalCommunicate
            if (result.data.version != null) {
              this.moreInfo.version = result.data.version
            }
          } else {
            this.$alert(result.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    getHistoricalCommunication() {
      // 获取历史沟通情况列表
      this.axios
        .get(
          this.homePath() +
            '/case-info/information-supplement/history-communicate/list/' +
            this.moreInfo.caseCode
        )
        .then((res) => {
          const result = res.data
          if (result.status == '000000') {
            this.historicalCommunicationList = result.data.historyCommunicate
            if (result.data.version != null) {
              this.moreInfo.version = result.data.version
            }
          } else {
            this.$alert(result.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    // ====================保存操作====================
    // 保存补充更多资料
    saveSupplement() {
      this.axios({
        url: this.homePath() + '/case-info/information-supplement',
        method: 'put',
        data: this.moreInfo,
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const result = res.data
          if (result.status == '000000') {
            this.$alert('修改成功')
            this.getMoreInfo()
          } else {
            this.$alert(result.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 保存不予互助沟通情况
    saveRefusalCommunicate() {
      this.refusalCommunicate.version = this.moreInfo.version
      this.refusalCommunicate.caseCode = this.moreInfo.caseCode

      this.axios({
        url:
          this.homePath() +
          '/case-info/information-supplement/save-refusal-communicate',
        method: 'put',
        data: this.refusalCommunicate,
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const result = res.data
          if (result.status == '000000') {
            this.$alert('修改成功')
            this.geTrefusalCommunicate()
            this.refusalCommunicate = this.refusalCommunicateObj()
          } else {
            this.$alert(result.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    /**
	 * 补充资料-保存事件概况
	 */
    saveEventOverview() {
      const vm = this
      var eventOverviewReqObj = {
        version: vm.moreInfo.version,
        caseCode: vm.moreInfo.caseCode,
        eventOverview: vm.eventOverviewContent
      }

      vm.axios({
        url:
          vm.homePath() +
          '/case-info/information-supplement/save-event-overview',
        method: 'put',
        data: JSON.stringify(eventOverviewReqObj),
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const result = res.data
          if (result.status == '000000') {
            vm.$alert('修改成功')
            vm.getEventOverview()
            vm.eventOverviewContent = null
          } else {
            vm.$alert(result.message || '服务器繁忙，请稍后重试', '提示')
		  }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 保存历史沟通情况
    saveHistoricalCommunicate() {
      this.historicalCommunication.version = this.moreInfo.version
      this.historicalCommunication.caseCode = this.moreInfo.caseCode

      this.axios({
        url:
          this.homePath() +
          '/case-info/information-supplement/save-historical-communication',
        method: 'put',
        data: JSON.stringify(this.historicalCommunication),
        headers: {
          'Content-type': 'application/json'
        }
      })
        .then((res) => {
          const result = res.data
          if (result.status == '000000') {
            this.$alert('修改成功')
            this.getHistoricalCommunication()
            this.historicalCommunication = this.historicalCommunicationObj()
          } else {
            this.$alert(result.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    historicalCommunicationObj() {
      return {
        version: null,
        caseCode: null,
        feedbackChannel: 0,
        feedbackType: 0,
        communicationDetail: null
      }
    },

    refusalCommunicateObj() {
      return {
        version: null,
        caseCode: null,
        refusalCommunicateContent: null,
        feedbackContent: null
      }
    },

    familyRecordItemObj() {
      return {
        familyMember: 0,
        specialJobMark: 0,
        name: null,
        phoneNumber: null,
        employer: null,
        position: null
      }
    },

    typeEnumsConvert(obj, allSelect) {
      for (var item in allSelect) {
        if (obj == allSelect[item].code) {
          return allSelect[item].name
        }
      }
    }
  }
}
</script>

<style>
</style>

